import React, { useState } from 'react';
import language from './LanguageSettings';
import notFoundWbgE from '../images/icon/notfound-wbg-e.png';
import notFoundWbgC from '../images/icon/notfound-wbg-c.png';

interface ImageFallbackProps {
  primarySrc: any;
  defaultSrc?: string;
  alt?: string;
  className?: string;
}

const ImageFallback: React.FC<ImageFallbackProps> = ({ primarySrc, defaultSrc, alt = 'Image', className}) => {
    if(defaultSrc == null || defaultSrc === ''){
      defaultSrc = `${notFoundWbgE}`;
      if(language === "zh"){
          defaultSrc = `${notFoundWbgC}`;
      }
    }
  const [currentSrc, setCurrentSrc] = useState(primarySrc ?? defaultSrc);

  const handleError = () => {
    setCurrentSrc(defaultSrc);
  };

  return (
    <img className={className} src={currentSrc} alt={alt} onError={handleError} />
  );
};

export default ImageFallback;